'use client';
import type { PropsWithChildren, ReactNode } from 'react';

import { AppInsightsUserLogger } from '../AppInsightsWrapper/useAppInsightsUserLogger';
import NoSSR from '../NoSSR';
import { FullstoryUserLogger } from './FullStoryUserLogger';

// Keep track of the current user
export function UserLogger({ children }: PropsWithChildren): ReactNode {
	return (
		<>
			{children}
			<NoSSR>
				<AppInsightsUserLogger />
				<FullstoryUserLogger />
			</NoSSR>
		</>
	);
}
